<template>
  <div :bordered="false" v-if="projectInfo.project">
    <div style="border: 1px solid rgb(235, 237, 240); margin-bottom: 30px">
      <a-page-header
        style="border: 0px solid rgb(235, 237, 240)"
        :title="projectInfo.project[0].name"
        @back="() => this.$router.back()"
      />
      <a-descriptions style="margin-top: 10px; margin-left: 20px;">
        <a-descriptions-item label="编号">
          {{ projectInfo.project[0].number }}
        </a-descriptions-item>
        <a-descriptions-item label="主体企业">
          {{ projectInfo.project[0].host_corporation }}
        </a-descriptions-item>
        <a-descriptions-item label="交易品种">
          {{ projectInfo.project[0].category }}
        </a-descriptions-item>
        <a-descriptions-item label="待落实前提条件" v-if="projectInfo.project[0].precondition">
          {{ projectInfo.project[0].precondition }}
        </a-descriptions-item>
        <a-descriptions-item label="现金" v-if="false">
          {{ (projectInfo.project[0].cash).toFixed(2) | numberFormat }}
        </a-descriptions-item>
        <a-descriptions-item label="起止时间" v-if="false">
          {{ projectInfo.project[0].start_date }} 至 {{ projectInfo.project[0].end_date }}
        </a-descriptions-item>
      </a-descriptions>
    </div>
    <a-space v-if="false" :size="space_size" class="space" style="display: flex; flex-wrap: wrap; gap: 10px;">
      <a-dropdown>
        <a-menu slot="overlay" @click="handleSellContractClick">
          <a-menu-item key="1"> <a-icon type="plus" />采购合同</a-menu-item>
          <a-menu-item key="2"> <a-icon type="plus" />销售合同</a-menu-item>
        </a-menu>
        <!-- @click="handleAdd('SellContractCreateForm')"-->
        <a-button style="width: 120px" type="primary" icon="plus">购销合同</a-button>
      </a-dropdown>
      <a-dropdown>
        <a-menu slot="overlay" @click="handleCustomsDeclarationClick">
          <a-menu-item key="1"> <a-icon type="plus" />进口</a-menu-item>
          <a-menu-item key="2"> <a-icon type="plus" />出口</a-menu-item>
        </a-menu>
        <a-button style="width: 120px" type="primary" icon="plus">报关信息</a-button>
      </a-dropdown>
      <a-dropdown>
        <a-menu slot="overlay" @click="handleContractClick">
          <a-menu-item v-for="(item, key) in dictionaries.trade_contract_type" :key="key">
            <a-icon type="plus" />{{ item }}
          </a-menu-item>
        </a-menu>
        <a-button style="width: 120px" type="primary" icon="plus">普通合同</a-button>
      </a-dropdown>
      <a-button style="width: 120px" type="primary" icon="plus" @click="handleLogisticsClick">物流信息</a-button>
      <a-button style="width: 120px" type="primary" icon="plus" @click="handleAdd('ProjectMaterialCreateForm')">资料</a-button>
      <a-dropdown>
        <a-menu slot="overlay" @click="handleInventoryClick">
          <a-menu-item v-for="(item, key) in dictionaries.trade_inventory_type" :key="key">
            <a-icon type="plus" />{{ item }}
          </a-menu-item>
        </a-menu>
        <a-button style="width: 120px" type="primary" icon="plus">出入库</a-button>
      </a-dropdown>

      <a-button style="width: 120px" type="primary" icon="plus" @click="handleAdd('PaymentCreateForm')">电汇付款</a-button>
      <a-button style="width: 120px" type="primary" icon="plus" @click="handleAdd('CollectionCreateForm')">收款</a-button>
      <a-button style="width: 120px" type="primary" icon="plus" @click="handleAdd('FapiaoCreateForm')">发票</a-button>
      <a-button style="width: 120px" type="primary" icon="plus" @click="handleAdd('CreditLetterCreateForm')">信用付款</a-button>
      <a-button style="width: 120px" type="primary" icon="plus" @click="handleAdd('CreditLetterRepaymentCreateForm')">信用证还款</a-button>
      <a-button style="width: 120px" type="primary" icon="plus" @click="handleAdd('ProjectCostCreateForm')">成本</a-button>
      <a-button style="width: 160px" type="primary" icon="plus" @click="handleAdd('SettlementCreateForm')">结算数量质量</a-button>
    </a-space>
    <a-spin :spinning="loading">
      <a-timeline>
        <a-timeline-item v-for="(item, index) in sortedProjectContentList" :key="(index + '' + item.id + item.content_type)">
          <template v-if="item.content_type === 'sell_contract'">
            <SellContractInfo
              :item="item"
              :index="index"
              :edit="true"
              @handleArchived="handleArchived"
              @handleEditRecord="handleEditRecord"
              @handleDelete="handleDelete"
              @approvalNeeded="approvalNeeded"/>
          </template>
          <template v-else-if="item.content_type === 'customs_declaration_in'">
            <CustomsDeclarationInInfo
              :item="item"
              :index="index"
              :edit="true"
              @handleArchived="handleArchived"
              @handleEditRecord="handleEditRecord"
              @handleDelete="handleDelete"
              @approvalNeeded="approvalNeeded"/>
          </template>
          <template v-else-if="item.content_type === 'customs_declaration_out'">
            <CustomsDeclarationOutInfo
              :item="item"
              :index="index"
              :edit="true"
              @handleArchived="handleArchived"
              @handleEditRecord="handleEditRecord"
              @handleDelete="handleDelete"
              @approvalNeeded="approvalNeeded"/>
          </template>
          <template v-else-if="item.content_type === 'logistics'">
            <LogisticsInfo
              :item="item"
              :index="index"
              :edit="true"
              @handleArchived="handleArchived"
              @handleEditRecord="handleEditRecord"
              @handleDelete="handleDelete"
              @approvalNeeded="approvalNeeded"/>
          </template>
          <template v-else-if="item.content_type === 'contract'">
            <ContractInfo
              :item="item"
              :index="index"
              :edit="true"
              @handleArchived="handleArchived"
              @handleEditRecord="handleEditRecord"
              @handleDelete="handleDelete"
              @approvalNeeded="approvalNeeded"/>
          </template>
          <template v-else-if="item.content_type === 'guarantee_contract'">
            <GuaranteeContractInfo
              :item="item"
              :index="index"
              :edit="true"
              @handleArchived="handleArchived"
              @handleEditRecord="handleEditRecord"
              @handleDelete="handleDelete"
              @approvalNeeded="approvalNeeded"/>
          </template>
          <template v-else-if="item.content_type === 'material'">
            <MaterialInfo
              :item="item"
              :index="index"
              :edit="true"
              @handleArchived="handleArchived"
              @handleEditRecord="handleEditRecord"
              @handleDelete="handleDelete"
              @approvalNeeded="approvalNeeded"/>
          </template>
          <template v-else-if="item.content_type === 'inventory'">
            <InventoryInfo
              :item="item"
              :index="index"
              :edit="true"
              @handleArchived="handleArchived"
              @handleEditRecord="handleEditRecord"
              @handleDelete="handleDelete"
              @approvalNeeded="approvalNeeded"
              @handleInventoryAdjust="handleInventoryAdjust"
            />
          </template>
          <template v-else-if="item.content_type === 'inventory_adjustment'">
            <InventoryAdjustmentInfo
              :item="item"
              :index="index"
              :edit="true"
              :projectContentList="projectContentList"
              @handleArchived="handleArchived"
              @handleEditRecord="handleEditRecord"
              @handleDelete="handleDelete"
              @approvalNeeded="approvalNeeded"
            />
          </template>
          <template v-else-if="item.content_type === 'payment'">
            <PaymentInfo
              :item="item"
              :index="index"
              :edit="true"
              @handleArchived="handleArchived"
              @handleEditRecord="handleEditRecord"
              @handleDelete="handleDelete"
              @approvalNeeded="approvalNeeded"
            />
          </template>
          <template v-else-if="item.content_type === 'collection'">
            <CollectionInfo
              :item="item"
              :index="index"
              :edit="true"
              @handleArchived="handleArchived"
              @handleEditRecord="handleEditRecord"
              @handleDelete="handleDelete"
              @approvalNeeded="approvalNeeded"
            />
          </template>
          <template v-else-if="item.content_type === 'fapiao'">
            <FaPiaoInfo
              :item="item"
              :index="index"
              :edit="true"
              @handleArchived="handleArchived"
              @handleEditRecord="handleEditRecord"
              @handleDelete="handleDelete"
              @approvalNeeded="approvalNeeded"
            />
          </template>
          <template v-else-if="item.content_type === 'credit_letter'">
            <CreditLetterInfo
              :item="item"
              :index="index"
              :edit="true"
              @handleArchived="handleArchived"
              @handleEditRecord="handleEditRecord"
              @handleDelete="handleDelete"
              @approvalNeeded="approvalNeeded"
              @handleCreditLetterDetailDone="handleCreditLetterDetailDone"
              @handleCreditLetterDone="handleCreditLetterDone"
            />
          </template>
          <template v-else-if="item.content_type === 'credit_letter_repayment'">
            <CreditLetterRepaymentInfo
              :item="item"
              :index="index"
              :edit="true"
              @handleArchived="handleArchived"
              @handleEditRecord="handleEditRecord"
              @handleDelete="handleDelete"
              @approvalNeeded="approvalNeeded"
              @handleAddBillNegotiation="handleAddBillNegotiation"
              @showBillNegotiation="showBillNegotiation"
            />
          </template>
          <template v-else-if="item.content_type === 'cost'">
            <CostInfo
              :item="item"
              :index="index"
              :edit="true"
              @handleArchived="handleArchived"
              @handleEditRecord="handleEditRecord"
              @handleDelete="handleDelete"
              @approvalNeeded="approvalNeeded"
            />
          </template>
          <template v-else-if="item.content_type === 'settlement'">
            <SettlementInfo
              :item="item"
              :index="index"
              :edit="true"
              @handleArchived="handleArchived"
              @handleEditRecord="handleEditRecord"
              @handleDelete="handleDelete"
              @approvalNeeded="approvalNeeded"
            />
          </template>
          <template v-else-if="item.content_type === 'lc_application'">
            <LcApplicationInfo
              :item="item"
              :index="index"
              :edit="true"
              @handleArchived="handleArchived"
              @handleEditRecord="handleEditRecord"
              @handleDelete="handleDelete"
              @approvalNeeded="approvalNeeded"
            />
          </template>
          <template v-else-if="item.content_type === 'payment_application'">
            <PaymentApplicationInfo
              :item="item"
              :index="index"
              :edit="true"
              @handleArchived="handleArchived"
              @handleEditRecord="handleEditRecord"
              @handleDelete="handleDelete"
              @approvalNeeded="approvalNeeded"
            />
          </template>
          <template v-else-if="item.content_type === 'fapiao_application'">
            <FapiaoApplicationInfo
              :item="item"
              :index="index"
              :edit="true"
              @handleArchived="handleArchived"
              @handleEditRecord="handleEditRecord"
              @handleDelete="handleDelete"
              @approvalNeeded="approvalNeeded"
            />
          </template>
        </a-timeline-item>
      </a-timeline>
    </a-spin>
    <component
      :ref="currentComponent"
      @cancel="handleAddCancel"
      @ok="handleOk"
      :record="mdl"
      :is="currentComponent"
      :visible="visible"
      v-if="visible"
      :loading="confirmLoading"
      :model="mdl" />
  </div>
</template>

<script>
import { STable } from '@/components'
import { Dictionaries } from '@/common/AllConstant'
import CreateForm from '../../modules/CreateForm'
import CustomsDeclarationInForm from '../../../customs_declaration/modules/CreateInForm'
import CustomsDeclarationOutForm from '../../../customs_declaration/modules/CreateOutForm'
import SellContractCreateForm from '../../../sell_contract/modules/CreateForm'
import SellContractCreateForm2 from '../../../sell_contract/modules/CreateForm2'
import ContractCreateForm from '../../../contract/modules/CreateForm'
import GuaranteeContractForm from '../../../contract/modules/GuaranteeContractForm'
import ProjectMaterialCreateForm from '../../../material/modules/CreateForm'
import ProjectLogisticsCreateForm from '../../../logistics/modules/CreateForm'
import InventoryCreateForm from '../../../inventory/modules/CreateForm'
import InventoryCreateForm2 from '../../../inventory/modules/CreateForm2'
import InventoryAdjustmentCreateForm from '../../../inventory/adjustment/modules/CreateForm'
import PaymentCreateForm from '../../../payment/modules/CreateForm'
import CollectionCreateForm from '../../../collection/modules/CreateForm'
import FapiaoCreateForm from '../../../fapiao/modules/CreateForm'
import CreditLetterCreateForm from '../../../credit_letter/modules/CreateForm'
import CreditLetterRepaymentCreateForm from '../../../credit_letter_repayment/modules/CreateForm'
import CreateBillNegotiationForm from '../../../credit_letter_repayment/modules/CreateBillNegotiationForm'
import BillNegotiationListForm from '../../../credit_letter_repayment/modules/BillNegotiationListForm'
import ProjectCostCreateForm from '../../../cost/modules/CreateForm'
import SellContractRecord from '../../modules/SellContractRecord'
import ContractRecord from '../../modules/ContractRecord'
import GuaranteeContractRecord from '../../modules/GuaranteeContractRecord'
import SettlementCreateForm from '../../../settlement/modules/CreateForm'
import SellContractInfo from '../../../project/modules/SellContractInfo'
import CustomsDeclarationInInfo from '../../../project/modules/CustomsDeclarationInInfo'
import CustomsDeclarationOutInfo from '../../modules/CustomsDeclarationOutInfo'
import LogisticsInfo from '../../modules/LogisticsInfo'
import ContractInfo from '../../modules/ContractInfo'
import GuaranteeContractInfo from '../../modules/GuaranteeContractInfo'
import MaterialInfo from '../../modules/MaterialInfo'
import InventoryInfo from '../../modules/InventoryInfo'
import InventoryAdjustmentInfo from '../../modules/InventoryAdjustmentInfo'
import PaymentInfo from '../../modules/PaymentInfo'
import CollectionInfo from '../../modules/CollectionInfo'
import FaPiaoInfo from '../../modules/FaPiaoInfo'
import CreditLetterInfo from '../../modules/CreditLetterInfo'
import CreditLetterRepaymentInfo from '../../modules/CreditLetterRepaymentInfo'
import CostInfo from '../../modules/CostInfo'
import SettlementInfo from '../../modules/SettlementInfo'
import LcApplicationInfo from '../../modules/LcApplicationInfo'
import PaymentApplicationInfo from '../../modules/PaymentApplicationInfo'
import FapiaoApplicationInfo from '../../modules/FapiaoApplicationInfo'
import { project_detail } from '@/api/trade_project'
import {
  sell_contract_archived,
  sell_contract_create,
  sell_contract_delete,
  sell_contract_update
} from '@/api/trade_sell_contract'
import { createProcessResult, getForms } from '@/api/oa_approve'
import { contract_archived, contract_create, contract_delete, contract_update } from '@/api/trade_contract'
import {
  project_material_archived,
  project_material_create,
  project_material_delete, project_material_update
} from '@/api/trade_project_material'
import { inventory_archived, inventory_create, inventory_delete, inventory_update } from '@/api/trade_inventory'
import { payment_archived, payment_create, payment_delete, payment_update } from '@/api/trade_payment'
import { fapiao_archived, fapiao_create, fapiao_delete, fapiao_update } from '@/api/trade_fapiao'
import {
  credit_letter_archived,
  credit_letter_create,
  credit_letter_delete,
  credit_letter_update
} from '@/api/trade_credit_letter'
import {
  credit_letter_repayment_archived,
  credit_letter_repayment_bill_negotiation_create,
  credit_letter_repayment_create,
  credit_letter_repayment_delete,
  credit_letter_repayment_update
} from '@/api/trade_credit_letter_repayment'
import {
  inventory_adjustment_archived,
  inventory_adjustment_create,
  inventory_adjustment_delete, inventory_adjustment_update
} from '@/api/trade_inventory_adjustment'
import { credit_letter_detail_update } from '@/api/trade_credit_letter_detail'
import { collection_archived, collection_create, collection_delete, collection_update } from '@/api/trade_collection'
import {
  project_cost_archived,
  project_cost_create,
  project_cost_delete,
  project_cost_update
} from '@/api/trade_project_cost'
import {
  customs_declaration_in_create, customs_declaration_in_update,
  customs_declaration_out_create, customs_declaration_out_update
} from '@/api/trade_customs_declaration'
import {
  guarantee_contract_create,
  guarantee_contract_delete,
  guarantee_contract_update
} from '@/api/trade_guarantee_contract'
import { settlement_create, settlement_delete, settlement_update } from '@/api/trade_settlement'
import { logistics_create, logistics_delete, logistics_update } from '@/api/trade_logistics'
import { getValueByKey } from '@/utils/util'

export default {
  name: 'TableList',
  components: {
    STable,
    CreateForm,
    SellContractCreateForm,
    SellContractCreateForm2,
    ContractCreateForm,
    GuaranteeContractForm,
    CustomsDeclarationInForm,
    CustomsDeclarationOutForm,
    ProjectMaterialCreateForm,
    ProjectLogisticsCreateForm,
    InventoryCreateForm,
    InventoryCreateForm2,
    InventoryAdjustmentCreateForm,
    PaymentCreateForm,
    CollectionCreateForm,
    FapiaoCreateForm,
    CreditLetterCreateForm,
    CreditLetterRepaymentCreateForm,
    ProjectCostCreateForm,
    CreateBillNegotiationForm,
    BillNegotiationListForm,
    SellContractRecord,
    ContractRecord,
    GuaranteeContractRecord,
    SettlementCreateForm,
    SellContractInfo,
    CustomsDeclarationInInfo,
    CustomsDeclarationOutInfo,
    LogisticsInfo,
    ContractInfo,
    GuaranteeContractInfo,
    MaterialInfo,
    InventoryInfo,
    InventoryAdjustmentInfo,
    PaymentInfo,
    CollectionInfo,
    FaPiaoInfo,
    CreditLetterInfo,
    CreditLetterRepaymentInfo,
    CostInfo,
    SettlementInfo,
    LcApplicationInfo,
    PaymentApplicationInfo,
    FapiaoApplicationInfo
  },
  data () {
    return {
      space_size: 8,
      loading: true,
      confirmLoading: false,
      recordVisible: false,
      contractRecordVisible: false,
      guaranteeContractRecordVisible: false,
      sellContractRecordList: [],
      contractRecordList: [],
      guaranteeContractRecordList: [],
      dictionaries: Dictionaries,
      un_approval_needed_text: '未开启审批',
      currentComponent: '',
      // 创建窗口控制
      visible: false,
      visibleBillNegotiation: false,
      mdl: {},
      inventoryMdl: {},
      statusText: {
        0: ['none', '无'],
        1: ['waiting', '审批中'],
        2: ['pass', '通过'],
        3: ['un_pass', '驳回']
      },
      guaranteeMethodList: this.$Dictionaries.guarantee_method,
      inventoryTypeList: [
        '入库',
        '出库',
        '平账'
      ],
      projectInfo: {},
      projectContentList: [],
      // 查询参数
      queryParam: {},
      selectedRowKeys: [],
      selectedRows: [],
      customStyle: 'background: #f7f7f7;border-radius: 4px;margin-bottom: 1px;border: 0;overflow: hidden',
      // custom table alert & rowSelection
      options: {
        alert: { show: true, clear: () => { this.selectedRowKeys = [] } },
        rowSelection: {
          selectedRowKeys: this.selectedRowKeys,
          onChange: this.onSelectChange
        }
      },
      optionAlertShow: false
    }
  },
  created () {
    this.tableOption()
    this.mdl.id = this.$route.query.record
    this.projectDetailInfo()
  },
  computed: {
    sortedProjectContentList () {
      return [...this.projectContentList].sort((a, b) => new Date(a.last_update) - new Date(b.last_update))
    },
    tradeType () {
      return (trade_type) => {
        switch (trade_type) {
          case 1:
            return '内贸'
          case 2:
            return '进口'
          case 3:
            return '出口'
        }
      }
    },
    futuresContractPreTitle () {
      return (index) => {
        if (index === 0) {
          return ''
        } else if (index === 1) {
          return '转月后'
        } else if (index === 2) {
          return '二次转月后'
        } else {
          return (index + 1) + '次转月后'
        }
      }
    },
    paymentMethodTitle () {
      return (payment_method) => {
        return payment_method <= 5 ? '预付款' + this.dictionaries.trade_pre_payment_method[payment_method] : '尾款' + this.dictionaries.trade_balance_payment_method[payment_method]
      }
    }
  },
  methods: {
    showDiffView (item) {
      this.recordVisible = !this.recordVisible
      if (this.recordVisible) {
        this.sellContractRecordList = item.sell_contract_record_list
      }
    },
    showContractDiffView (item) {
      this.contractRecordVisible = !this.contractRecordVisible
      if (this.contractRecordVisible) {
        this.contractRecordList = item.contract_record_list
      }
    },
    showGuaranteeContractDiffView (item) {
      this.guaranteeContractRecordVisible = !this.guaranteeContractRecordVisible
      if (this.guaranteeContractRecordVisible) {
        this.guaranteeContractRecordList = item.guarantee_contract_record_list
      }
    },
    tableOption () {
      if (!this.optionAlertShow) {
        this.options = {
          alert: { show: true, clear: () => { this.selectedRowKeys = [] } },
          rowSelection: {
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        }
        this.optionAlertShow = true
      } else {
        this.options = {
          alert: false,
          rowSelection: null
        }
        this.optionAlertShow = false
      }
    },
    handleSellContractClick (e) {
      console.log('click', e)
      this.mdl['type'] = e.key
      this.handleAdd('SellContractCreateForm2')
    },
    handleCustomsDeclarationClick (e) {
      console.log('click', e)
      this.mdl['type'] = e.key
      this.mdl['project_id'] = this.$route.params.project_id
      if (e.key === '1') {
        this.handleAdd('CustomsDeclarationInForm')
      } else {
        this.handleAdd('CustomsDeclarationOutForm')
      }
    },
    handleContractClick (e) {
      const key = Number(e.key)
      this.mdl['type'] = key
      this.mdl['project_id'] = this.$route.params.project_id
      if (key === Object.keys(this.$Dictionaries.trade_contract_type).length) {
        this.handleAdd('GuaranteeContractForm')
      } else {
        this.handleAdd('ContractCreateForm')
      }
    },
    handleInventoryClick (e) {
      console.log('click', e)
      this.mdl['type'] = Number(e.key)
      this.mdl['project_id'] = this.$route.params.project_id
      this.handleAdd('InventoryCreateForm2')
    },
    handleLogisticsClick () {
      this.mdl['project_id'] = this.$route.params.project_id
      this.handleAdd('ProjectLogisticsCreateForm')
    },
    handleAdd (component) {
      const date = new Date()
      const hours = date.getHours() > 9 ? date.getHours() : '0' + date.getHours()
      const minutes = date.getMinutes() > 9 ? date.getMinutes() : '0' + date.getMinutes()
      this.mdl = { number: this.projectInfo.project[0].number + hours + minutes, ...this.mdl }
      this.currentComponent = component
      this.visible = true
    },
    handleAddSellContract () {
      this.visible = true
    },
    handleAddCancel () {
      this.visible = false
      const form = this.$refs[this.currentComponent].form
      form.resetFields() // 清理表单数据（可不做）
    },
    handleEdit (record) {
      // this.$emit('onEdit', record)
      this.$router.push({ path: '/trade/project/' + record.id })
    },
    handleClient (record) {
      // this.$emit('onEdit', record)
      this.$router.push({ path: '/trade/project/' + record.id + '/client', query: { record: record.host_corporation } })
    },
    handleRemark (record) {
      // this.$emit('onEdit', record)
      this.$router.push({ path: '/trade/project/' + record.id + '/remark', query: { record: record.host_corporation } })
    },
    handleDetail (record) {
      console.log(record)
    },
    handleDelete (record, type) {
      this.loading = true
      this.deleteByType(type)(record.id).then(res => {
        if (res.code === 1000) {
          this.projectDetailInfo()
        } else {
          this.loading = false
        }
      })
    },
    handleArchived (record, type) {
      this.loading = true
      this.archivedByType(type)({ id: record.id, is_archived: true }).then(res => {
        if (res.code === 1000) {
          this.projectDetailInfo()
        } else {
          this.loading = false
        }
      })
    },
    handleOk (data) {
      const form = this.$refs[this.currentComponent].form
      form.validateFields((errors, values) => {
        if (!errors) {
          console.log('values', values, data)
            // 新增
          values.project_id = this.$route.params.project_id
          if (this.currentComponent === 'SellContractCreateForm2') {
            const { values_new, data_new } = this.unitPriceValues(values, data)
            if (data_new.product_parameters !== undefined) {
              data_new.product_parameters = data_new.product_parameters.map(item => {
                delete item['key']
                return item
              })
            }
            values = { ...values_new, ...data_new }
          } else {
            values = { ...values, ...data }
          }
          if (this.currentComponent === 'CreateBillNegotiationForm') {
            this.createBillNegotiation(values)
            return
          } else if (this.currentComponent === 'BillNegotiationListForm') {
            this.handleAddCancel()
            return
          }
          if (this.currentComponent === 'InventoryAdjustmentCreateForm') {
            values.inventory_id = this.mdl.id
          } else if (this.currentComponent === 'InventoryCreateForm2') {
            values['type'] = this.mdl['type']
          } else if (this.currentComponent === 'ContractCreateForm') {
            values['type'] = this.mdl['type']
          }
          if (values.is_approval_needed) {
            values.status = 1
            this.createProjectContentAndApproval(values, form)
          } else {
            this.createProjectContent(values, form)
          }
        } else {
          this.confirmLoading = false
        }
      })
    },
    unitPriceValues (values, data) {
      // 单价
      if (values) {
        if (values['unit_price_type'] === '2') {
          const turning_month_list = []
          const start_date = values['pricing_period'][0].format('YYYY-MM-DD')
          const end_date = values['pricing_period'][1].format('YYYY-MM-DD')
          const futures_contract = values['futures_contract']
          const lock_up_date = values['lock_up_date']
          turning_month_list.push({
            futures_contract: futures_contract,
            lock_up_date: lock_up_date,
            pricing_period_start_date: start_date,
            pricing_period_end_date: end_date
          })
          values['futures_contract'] = undefined
          values['lock_up_date'] = undefined
          values['pricing_period'] = undefined
          if (data.turning_month_list.length > 0) {
            const data_list = data.turning_month_list.map(item => {
              // const start_date = item['pricing_period']['start_date']
              // const end_date = item['pricing_period']['end_date']
              // item['pricing_period_start_date'] = start_date
              // item['pricing_period_end_date'] = end_date
              // item['pricing_period'] = undefined
              item['key'] = undefined
              return item
            })
            turning_month_list.push(...data_list)
          }
          data.turning_month_list = turning_month_list
          // values['turning_month_list'] = turning_month_list
        } else if (values['unit_price_type'] === '3') {
          if (values['price_reference_period']) {
            const start_date = values['price_reference_period'][0].format('YYYY-MM-DD')
            const end_date = values['price_reference_period'][1].format('YYYY-MM-DD')
            values['price_reference_period'] = undefined
            values['price_reference_period_start_date'] = start_date
            values['price_reference_period_end_date'] = end_date
          }
        }
      }
      return {
        values_new: values,
        data_new: data
      }
    },
    createProjectContent (values, form, typeCategory = undefined, templateId = -1, is_approval_needed = false) {
      // 创建项目内容
      if (!this.confirmLoading) {
        this.confirmLoading = true
      }
      this.createByType()(values).then(res => {
        this.visible = false
        // 重置表单数据
        form.resetFields()
        // 刷新表格
        if (res.code === 1000) {
          if (is_approval_needed) {
            this.createProjectContentApproval(res.data.id, typeCategory, templateId, false)
          } else {
            this.projectDetailInfo()
          }
        }
      }).finally(() => {
        this.confirmLoading = false
      })
    },
    createByType () {
      if (this.currentComponent === 'SellContractCreateForm') {
        return sell_contract_create
      } else if (this.currentComponent === 'SellContractCreateForm2') {
        return sell_contract_create
      } else if (this.currentComponent === 'CustomsDeclarationInForm') {
        return customs_declaration_in_create
      } else if (this.currentComponent === 'CustomsDeclarationOutForm') {
        return customs_declaration_out_create
      } else if (this.currentComponent === 'GuaranteeContractForm') {
        return guarantee_contract_create
      } else if (this.currentComponent === 'ContractCreateForm') {
        return contract_create
      } else if (this.currentComponent === 'ProjectMaterialCreateForm') {
        return project_material_create
      } else if (this.currentComponent === 'ProjectLogisticsCreateForm') {
        return logistics_create
      } else if (this.currentComponent === 'InventoryCreateForm') {
        return inventory_create
      } else if (this.currentComponent === 'InventoryCreateForm2') {
        return inventory_create
      } else if (this.currentComponent === 'InventoryAdjustmentCreateForm') {
        return inventory_adjustment_create
      } else if (this.currentComponent === 'PaymentCreateForm') {
        return payment_create
      } else if (this.currentComponent === 'CollectionCreateForm') {
        return collection_create
      } else if (this.currentComponent === 'FapiaoCreateForm') {
        return fapiao_create
      } else if (this.currentComponent === 'CreditLetterCreateForm') {
        return credit_letter_create
      } else if (this.currentComponent === 'CreditLetterRepaymentCreateForm') {
        return credit_letter_repayment_create
      } else if (this.currentComponent === 'ProjectCostCreateForm') {
        return project_cost_create
      } else if (this.currentComponent === 'SettlementCreateForm') {
        return settlement_create
      }
    },
    deleteByType (type) {
      if (type === 'sell_contract') {
        return sell_contract_delete
      } else if (type === 'contract') {
        return contract_delete
      } else if (type === 'guarantee_contract') {
        return guarantee_contract_delete
      } else if (type === 'project_material') {
        return project_material_delete
      } else if (type === 'inventory') {
        return inventory_delete
      } else if (type === 'inventory_adjustment') {
        return inventory_adjustment_delete
      } else if (type === 'payment') {
        return payment_delete
      } else if (type === 'collection') {
        return collection_delete
      } else if (type === 'fapiao') {
        return fapiao_delete
      } else if (type === 'credit_letter') {
        return credit_letter_delete
      } else if (type === 'credit_letter_repayment') {
        return credit_letter_repayment_delete
      } else if (type === 'project_cost') {
        return project_cost_delete
      } else if (type === 'settlement') {
        return settlement_delete
      } else if (type === 'logistics') {
        return logistics_delete
      }
    },
    archivedByType (type) {
      if (type === 'sell_contract') {
        return sell_contract_archived
      } else if (type === 'contract') {
        return contract_archived
      } else if (type === 'project_material') {
        return project_material_archived
      } else if (type === 'inventory') {
        return inventory_archived
      } else if (type === 'inventory_adjustment') {
        return inventory_adjustment_archived
      } else if (type === 'payment') {
        return payment_archived
      } else if (type === 'collection') {
        return collection_archived
      } else if (type === 'fapiao') {
        return fapiao_archived
      } else if (type === 'credit_letter') {
        return credit_letter_archived
      } else if (type === 'credit_letter_repayment') {
        return credit_letter_repayment_archived
      } else if (type === 'project_cost') {
        return project_cost_archived
      }
    },
    approvalNeededByType (type) {
      if (type === 'trade_sell_contract') {
        return sell_contract_update
      } else if (type === 'trade_contract') {
        return contract_update
      } else if (type === 'trade_guarantee_contract') {
        return guarantee_contract_update
      } else if (type === 'trade_customs_declaration_in') {
        return customs_declaration_in_update
      } else if (type === 'trade_customs_declaration_out') {
        return customs_declaration_out_update
      } else if (type === 'trade_project_material' || type === 'trade_material') {
        return project_material_update
      } else if (type === 'trade_inventory') {
        return inventory_update
      } else if (type === 'trade_inventory_adjustment') {
        return inventory_adjustment_update
      } else if (type === 'trade_payment') {
        return payment_update
      } else if (type === 'trade_collection') {
        return collection_update
      } else if (type === 'trade_fapiao') {
        return fapiao_update
      } else if (type === 'trade_credit_letter') {
        return credit_letter_update
      } else if (type === 'trade_credit_letter_repayment') {
        return credit_letter_repayment_update
      } else if (type === 'trade_logistics') {
        return logistics_update
      } else if (type === 'trade_cost') {
        return project_cost_update
      } else if (type === 'trade_settlement') {
        return settlement_update
      }
    },
    filterComponentApprovalType () {
      if (this.currentComponent === 'SellContractCreateForm') {
        return 'trade_sell_contract'
      } else if (this.currentComponent === 'SellContractCreateForm2') {
        return 'trade_sell_contract'
      } else if (this.currentComponent === 'CustomsDeclarationInForm') {
        return 'trade_customs_declaration_in'
      } else if (this.currentComponent === 'CustomsDeclarationOutForm') {
        return 'trade_customs_declaration_out'
      } else if (this.currentComponent === 'GuaranteeContractForm') {
        return 'trade_guarantee_contract'
      } else if (this.currentComponent === 'ContractCreateForm') {
        return 'trade_contract'
      } else if (this.currentComponent === 'InventoryCreateForm') {
        return 'trade_inventory'
      } else if (this.currentComponent === 'InventoryCreateForm2') {
        return 'trade_inventory'
      } else if (this.currentComponent === 'InventoryAdjustmentCreateForm') {
        return 'trade_inventory_adjustment'
      } else if (this.currentComponent === 'PaymentCreateForm') {
        return 'trade_payment'
      } else if (this.currentComponent === 'CollectionCreateForm') {
        return 'trade_collection'
      } else if (this.currentComponent === 'FapiaoCreateForm') {
        return 'trade_fapiao'
      } else if (this.currentComponent === 'ProjectLogisticsCreateForm') {
        return 'trade_logistics'
      } else if (this.currentComponent === 'CreditLetterCreateForm') {
        return 'trade_credit_letter'
      } else if (this.currentComponent === 'CreditLetterRepaymentCreateForm') {
        return 'trade_credit_letter_repayment'
      } else if (this.currentComponent === 'ProjectCostCreateForm') {
        return 'trade_cost'
      } else if (this.currentComponent === 'SettlementCreateForm') {
        return 'trade_settlement'
      } else if (this.currentComponent === 'ProjectMaterialCreateForm') {
        return 'trade_material'
      } else {
        return undefined
      }
    },
    handleInventoryAdjust (record) {
      const date = new Date()
      const hours = date.getHours() > 9 ? date.getHours() : '0' + date.getHours()
      const minutes = date.getMinutes() > 9 ? date.getMinutes() : '0' + date.getMinutes()
      this.mdl = { number: this.projectInfo.project[0].number + hours + minutes, ...record }
      this.currentComponent = 'InventoryAdjustmentCreateForm'
      this.visible = true
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    projectDetailInfo () {
      if (!this.loading) {
        this.loading = true
      }
      project_detail({ project_id: this.$route.params.project_id }).then(res => {
        console.log(res)
        if (res.code !== 1000) {
          this.$router.back()
          return
        }
        this.projectInfo = res.data
        this.projectContentList = []
        if (this.projectInfo.sell_contract_list) {
          this.projectContentList.push(...this.projectInfo.sell_contract_list.map(item => {
            item.content_type = 'sell_contract'
            return item
          }))
        }
        if (this.projectInfo.customs_declaration_in_list) {
          this.projectContentList.push(...this.projectInfo.customs_declaration_in_list.map(item => {
            item.content_type = 'customs_declaration_in'
            return item
          }))
        }
        if (this.projectInfo.customs_declaration_out_list) {
          this.projectContentList.push(...this.projectInfo.customs_declaration_out_list.map(item => {
            item.content_type = 'customs_declaration_out'
            return item
          }))
        }
        if (this.projectInfo.logistics_list) {
          this.projectContentList.push(...this.projectInfo.logistics_list.map(item => {
            item.content_type = 'logistics'
            return item
          }))
        }
        if (this.projectInfo.contract_list) {
          this.projectContentList.push(...this.projectInfo.contract_list.map(item => {
            item.content_type = 'contract'
            return item
          }))
        }
        if (this.projectInfo.guarantee_contract_list) {
          this.projectContentList.push(...this.projectInfo.guarantee_contract_list.map(item => {
            item.type = 12
            item.content_type = 'guarantee_contract'
            return item
          }))
        }
        if (this.projectInfo.material_list) {
          this.projectContentList.push(...this.projectInfo.material_list.map(item => {
            item.content_type = 'material'
            return item
          }))
        }
        if (this.projectInfo.inventory_list) {
          this.projectContentList.push(...this.projectInfo.inventory_list.map(item => {
            item.content_type = 'inventory'
            return item
          }))
        }
        if (this.projectInfo.inventory_adjustment_list) {
          this.projectContentList.push(...this.projectInfo.inventory_adjustment_list.map(item => {
            item.content_type = 'inventory_adjustment'
            return item
          }))
        }
        if (this.projectInfo.payment_list) {
          this.projectContentList.push(...this.projectInfo.payment_list.map(item => {
            item.content_type = 'payment'
            return item
          }))
        }
        if (this.projectInfo.collection_list) {
          this.projectContentList.push(...this.projectInfo.collection_list.map(item => {
            item.content_type = 'collection'
            return item
          }))
        }
        if (this.projectInfo.payment_list) {
          this.projectContentList.push(...this.projectInfo.fapiao_list.map(item => {
            item.content_type = 'fapiao'
            return item
          }))
        }
        if (this.projectInfo.credit_letter_list) {
          this.projectContentList.push(...this.projectInfo.credit_letter_list.map(item => {
            item.content_type = 'credit_letter'
            return item
          }))
        }
        if (this.projectInfo.credit_letter_repayment_list) {
          this.projectContentList.push(...this.projectInfo.credit_letter_repayment_list.map(item => {
            item.content_type = 'credit_letter_repayment'
            return item
          }))
        }
        if (this.projectInfo.cost_list) {
          this.projectContentList.push(...this.projectInfo.cost_list.map(item => {
            item.content_type = 'cost'
            return item
          }))
        }
        if (this.projectInfo.settlement_list) {
          this.projectContentList.push(...this.projectInfo.settlement_list.map(item => {
            item.content_type = 'settlement'
            return item
          }))
        }
        if (this.projectInfo.lc_application_list) {
          this.projectContentList.push(...this.projectInfo.lc_application_list.map(item => {
            item.content_type = 'lc_application'
            return item
          }))
        }
        if (this.projectInfo.payment_application_list) {
          this.projectContentList.push(...this.projectInfo.payment_application_list.map(item => {
            item.content_type = 'payment_application'
            return item
          }))
        }
        if (this.projectInfo.fapiao_application_list) {
          this.projectContentList.push(...this.projectInfo.fapiao_application_list.map(item => {
            item.content_type = 'fapiao_application'
            return item
          }))
        }
      }).catch(error => {
        console.log(error)
        this.$router.back()
      }).finally(() => {
        this.loading = false
      })
    },
    approvalNeeded (record, type, approval_again = false) {
      const is_approval_needed = approval_again ? true : !record.is_approval_needed
      if (is_approval_needed) {
        this.checkAndGetApprovalTemplate(type).then(({ typeCategory, templateId }) => {
          if (templateId) {
            this.loading = true
            return this.approvalNeededByType(type)(
              { is_approval_needed: is_approval_needed },
              record.id
            ).then(res => {
              return { res, typeCategory, templateId }
            })
          }
        }).then(({ res, typeCategory, templateId }) => {
          if (res.code === 1000) {
            this.createProcessNotice(templateId, record.id, typeCategory, approval_again)
          } else {
            this.loading = false
          }
        }).catch(err => {
          console.error(err)
          this.loading = false
        })
      }
    },
    createProjectContentApproval (id, typeCategory, templateId, approval_again) {
      // 生成审批
      if (templateId) {
        this.loading = true
        this.createProcessNotice(templateId, id, typeCategory, approval_again)
      }
    },
    createProjectContentAndApproval (values, form) {
      // 创建项目内容
      // 创建项目内容审批
      const type = this.filterComponentApprovalType()
      if (type === undefined) {
        this.$message.warning('审批类型不确定')
        return
      }
      this.confirmLoading = true
      this.checkAndGetApprovalTemplate(type).then(({ typeCategory, templateId }) => {
        if (templateId) {
          this.createProjectContent(values, form, typeCategory, templateId, true)
        }
      }).finally(() => {
        this.confirmLoading = false
      })
    },
    createProcessNotice (template_id, id, typeCategory, approval_again = false) {
      const data = {
        'data_id': id,
        'template_id': template_id,
        'category': typeCategory,
        'approval_again': approval_again
      }
      createProcessResult(data).then(res => {
        console.log(res)
        if (res.code === 1000) {
          this.projectDetailInfo()
        }
      })
    },
    handleEditRecord (record, type) {
      if (type === 'inventory_adjustment') {
        console.log(record, type)
        this.$router.push({ path: '/trade/inventory/' + record.inventory_id + '/adjustment/' + record.id })
        return
      }
      this.$router.push({ path: '/trade/' + type + '/' + record.id, query: { type: record.type, project_id: this.$route.params.project_id } })
    },
    handleCreditLetterDone (record) {
      if (record.is_approval_needed && record.status === 1) {
        this.$message.warning('审批还未结束')
        return
      }
      credit_letter_update({ is_done: true }, record.id).then(res => {
        if (res.code === 1000) {
          this.projectDetailInfo()
        }
      })
    },
    handleCreditLetterDetailDone (record) {
      credit_letter_detail_update({ is_done: true }, record.id).then(res => {
        if (res.code === 1000) {
          this.projectDetailInfo()
        }
      })
    },
    getInventoryNumber (inventory_id) {
      let index = 0
      this.sortedProjectContentList.forEach((item, i) => {
        if (item.id === inventory_id && item.content_type === 'inventory') {
          index = i + 1
        }
      })
      return index
    },
    handleAddBillNegotiation (record, component) {
      console.log(record)
      this.mdl = { credit_letter_repayment_id: record.id }
      this.currentComponent = component
      this.visible = true
    },
    createBillNegotiation (values) {
      const data = { ...values, credit_letter_repayment_id: this.mdl.credit_letter_repayment_id }
      credit_letter_repayment_bill_negotiation_create(data).then(res => {
        console.log(res)
        if (res.code === 1000) {
          this.visible = false
          this.projectDetailInfo()
        }
      }).finally(() => {
        if (this.confirmLoading) {
          this.confirmLoading = false
        }
      })
    },
    showBillNegotiation (item) {
      if (item.repayment_bill_negotiation_limit === 0) {
        this.$message.info('暂无数据')
        return
      }
      this.mdl = item
      this.currentComponent = 'BillNegotiationListForm'
      this.visible = true
    },
    checkAndGetApprovalTemplate (type) {
      return new Promise((resolve, reject) => {
        const typeValue = getValueByKey(type, this.$Dictionaries.approval_category)
        let typeCategory

        if (typeValue === undefined) {
          this.$message.warning('没有对应的审批')
          return reject(new Error('没有对应的审批'))
        } else if (Array.isArray(typeValue)) {
          typeCategory = typeValue.join(',')
        }

        if (!typeCategory) {
          this.$message.warning('没有对应的审批')
          return reject(new Error('没有对应的审批'))
        }

        getForms({ is_stop: 0, category: typeCategory })
          .then(res => {
            const shenpi_list = res.data?.entries || []
            if (shenpi_list.length > 0) {
              // 可选：查找匹配 category 的 templateId
              let templateId
              for (let i = 0, len = shenpi_list.length; i < len; i++) {
                if (shenpi_list[i].category === typeCategory) {
                  templateId = shenpi_list[i].id
                }
              }
              resolve({
                typeCategory,
                templateId,
                shenpi_list
              })
            } else {
              if (this.confirmLoading) this.confirmLoading = false
              this.$message.warning('先创建审批模板')
              reject(new Error('先创建审批模板'))
            }
          })
          .catch(err => {
            console.error(err)
            if (this.confirmLoading) this.confirmLoading = false
            reject(err)
          })
      })
    }
  }
}
</script>
<style scoped>
  .desc {
    padding-right: 20px;
    height: 40px;
    line-height: 40px;
    display: inline-block;
  }
  .row_item {
    border-bottom: 1px solid #eeeeee;
    padding: 10px 20px;
    background-color: #f7f7f7;
    margin-top: 5px;
    border-radius: 10px;
  }
  .ope>span:hover {
    color: #2a99ff;
    cursor: pointer;
  }
  .ope>span:first-child {
    padding-left: 0px;
    height: 40px;
    line-height: 40px;
  }
  .ope>span:not(:first-child) {
    padding-left: 20px;
    height: 40px;
    line-height: 40px;
  }
  .content {
    /*color: #00A0E9;*/
    /*font-weight: bolder*/
  }
  .none {
    color: #333333;
  }
  .waiting {
    color: yellowgreen;
  }
  .pass {
    color: green;
  }
  .un_pass {
    color: red;
  }
  .space {
    margin-top: 5px;
    overflow-x: auto;
  }
  .important-content {
    font-weight: bold;
  }
</style>
